<template>
  <div class="custom-card">
    <v-toolbar-title class="mb-4 py-2" style="border-bottom: 1px solid #d4dbe0">
      <span>PAGOS: SEDE UNIVERSIDAD</span>
    </v-toolbar-title>

    <v-row dense>
      <v-col cols="12" md="9" xl="10">
        <template v-if="permisosAcademicosNacional">
          <v-btn
            class="mx-1"
            color="primary"
            title="Registrar"
            small
            @click="$refs.modalFormularioSedeUniversidadRef.abrir(accionesCrud.REGISTRAR, [])">
            <v-icon>mdi-plus</v-icon>

            Registrar
          </v-btn>

          <v-btn
            class="mx-1"
            title="Editar"
            small
            :disabled="item == null"
            @click="$refs.modalFormularioSedeUniversidadRef.abrir(accionesCrud.EDITAR, item)">
            <v-icon>mdi-pencil</v-icon>

            Editar
          </v-btn>

          <v-btn
            class="mx-1"
            title="Eliminar"
            small
            :disabled="item == null"
            @click="() => confirmacionAccion(accionesAConfirmar.ELIMINAR, nombreItem, `${item.codigo} ${item.nombre}`)">
            <v-icon>mdi-close</v-icon>

            Eliminar
          </v-btn>
        </template>

        <v-btn class="mx-1" title="Recargar" small @click="listar">
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
      </v-col>

      <v-col cols="12" md="3" xl="2">
        <v-text-field
          dense
          outlined
          hide-details
          v-model="searchQuery"
          append-icon="mdi-magnify"
          label="Buscar"
          clearable
          @input="updateSearchQuery"></v-text-field>
      </v-col>

      <v-col cols="12">
        <ListadoSedeUniversidad ref="listadoRef" :items="items" :cargando="cargando" @selectItem="selectItem" />
      </v-col>
    </v-row>

    <ModalFormularioSedeUniversidad
      ref="modalFormularioSedeUniversidadRef"
      :nombreRecurso="nombreItem"
      @actualizarListado="listar" />

    <ConfirmacionAccion
      ref="confirmacionRef"
      :titulo="confirmacion.titulo"
      :mensaje="confirmacion.mensaje"
      :realizandoAccion="confirmacion.realizandoAccion"
      @aceptar="confirmacion.fnAceptar" />

    <notifications group="notifications" position="top right" />
  </div>
</template>

<script>
import ListadoSedeUniversidad from '../components/ListadoSedeUniversidad.vue';
import SedeUniversidadService from '../services/sede-universidad.service';
import ModalFormularioSedeUniversidad from '../components/ModalFormularioSedeUniversidad.vue';
import layoutMixin from '../mixins/layout.mixin';
import apiConsumerMixin from '../mixins/api-consumer.mixin';
import { mapGetters } from 'vuex';

export default {
  name: 'SedeUniversidadLayout',
  mixins: [layoutMixin, apiConsumerMixin],
  components: {
    ListadoSedeUniversidad,
    ModalFormularioSedeUniversidad,
  },
  data() {
    return {
      nombreItem: 'Sede Universidad',
    };
  },
  mounted() {
    this.listar();
  },
  computed: {
    ...mapGetters({
      permisosAcademicosNacional: 'pago/permisosAcademicosNacional',
    }),
  },
  methods: {
    listar() {
      const params = {};

      this.obtenerDatosConNotificacion(SedeUniversidadService.findAll, 'items', this.nombreItem, params);

      this.item = null;
    },
    async getResponseAccion(accion) {
      let response = null;

      if (accion === this.accionesAConfirmar.ELIMINAR) {
        response = await SedeUniversidadService.remove(this.item.id);
      }

      return response;
    },
  },
};
</script>

<style scoped>
.custom-card {
  border: 1px solid #dfdfdf;
  padding: 8px;
  margin: 0px 8px 0px 8px;
}

::v-deep .custom-pagination .v-pagination__item,
::v-deep .custom-pagination .v-pagination__navigation {
  height: 28px;
  min-width: 28px;
  margin: 0px 4px;
}

::v-deep .v-select.v-text-field--outlined:not(.v-text-field--single-line).v-input--dense .v-select__selections {
  padding: 0px 0;
}

::v-deep .v-text-field .v-input__control .v-input__slot {
  min-height: auto !important;
  display: flex !important;
  align-items: center !important;
}

::v-deep .v-text-field--outlined.v-input--dense .v-label {
  top: 5px;
}

::v-deep .v-text-field .v-label {
  font-weight: 400;
}
</style>